import { z } from "zod";

export const AwCompanyIdSchema = z.object({
	aw_company_id: z.string()
});

export type AwCompanyId = z.infer<typeof AwCompanyIdSchema>;
